import { render, staticRenderFns } from "./SinglePane.vue?vue&type=template&id=0d8c0ec2&scoped=true&"
import script from "./SinglePane.vue?vue&type=script&lang=js&"
export * from "./SinglePane.vue?vue&type=script&lang=js&"
import style0 from "./SinglePane.vue?vue&type=style&index=0&id=0d8c0ec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8c0ec2",
  null
  
)

export default component.exports